module.exports = {
      id: "cricket-usage",
      viewBox: "0 0 21.217 19.952",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#cricket",
      toString: function () {
        return this.url;
      }
    }